var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 31 31",
    width: 79,
    height: 79,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#d20723;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M23.83,9.19a3.31,3.31,0,1,0-3.31-3.31A3.31,3.31,0,0,0,23.83,9.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M6.59,19.81A3.32,3.32,0,1,0,9.9,23.13,3.32,3.32,0,0,0,6.59,19.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M26.34,22.33A4,4,0,0,0,24.2,23l-2.91-3a7.79,7.79,0,0,0,2-4.44,2.61,2.61,0,0,1,.56-.08,2.22,2.22,0,0,1,1.62.71.41.41,0,0,1,.09.1,2.18,2.18,0,0,0,1.62.71,2.22,2.22,0,1,0,0-4.43,2.19,2.19,0,0,0-1.62.72l-.09.09a2.18,2.18,0,0,1-1.62.71,2.1,2.1,0,0,1-.56-.08,7.78,7.78,0,0,0-7-7,3.16,3.16,0,0,1,0-.32,2.18,2.18,0,0,1,.71-1.62A.43.43,0,0,1,17,5,2.21,2.21,0,1,0,13.3,3.34,2.18,2.18,0,0,0,14,5l.1.09a2.22,2.22,0,0,1,.71,1.62,1.65,1.65,0,0,1,0,.32,7.85,7.85,0,0,0-4.3,1.81l-2.89-3A4,4,0,1,0,4,8a4,4,0,0,0,2.21-.67l2.88,3A7.7,7.7,0,0,0,7.76,14l-.2,0a2.18,2.18,0,0,1-1.62-.71l-.08-.09A2.21,2.21,0,1,0,4.23,17a2.18,2.18,0,0,0,1.62-.71l.09-.09a2.19,2.19,0,0,1,1.62-.72l.2,0a7.79,7.79,0,0,0,7,7,2,2,0,0,1,0,.34,2.21,2.21,0,0,1-.72,1.63l-.09.08a2.21,2.21,0,1,0,3.72,1.63A2.26,2.26,0,0,0,17,24.55a.39.39,0,0,1-.1-.08,2.2,2.2,0,0,1-.71-1.63c0-.11,0-.23,0-.34a7.78,7.78,0,0,0,3.47-1.2l3.09,3.19a4,4,0,1,0,3.54-2.16Z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.e5bf8c6d.svg";
export { ForwardRef as ReactComponent };